import * as React from 'react';
import * as styles from '../../Megamenu.css';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from './../../../stores';
import { MobileElementGroup } from '../../mobileElementGroup/MobileElementGroup';
import { IAIcon } from '../../../../icon/Icon';
import { LoggingService } from '../../../../../services/LoggingService';
import "../../../../../styles/BasicIA.css";
import { DOWNARROW_KEY, ENTER_KEY } from '../../../../../global/Constants';
import { KeyNavigationGlobalCache } from '../../../KeyNavigationGlobalCache';
import { Helper } from '../../../../../Helper';
import { IAConditionalTooltipWrapper } from '../../../../tooltip/ConditionalTooltipWrapper';
import { NavigatorTargetingTooltip } from '../../targetingTooltip/TargetingTooltop';


export interface ITopItemProps {
  navigatorStore?: NavigatorStore;
  config: any;
  type: string;
  elementGroups: any[];
  index: number;
  updateItems: () => void;
}

@inject('navigatorStore')
@observer
export class TopItem extends React.Component<ITopItemProps> {
  private readonly constructorName = "NavigatorTopItem";
  private getTargetingInfo(seperator?: string): string {
    return this.props.navigatorStore.GetUserGroupTargetingForNavigatorAnalytics(this.props.navigatorStore.navigator.megamenu.topItems[this.props.index]?.targeting, this.props.navigatorStore.applicationSettings?.applicationSettings, seperator);
  }

  private onHeaderClick() {
    if (!this.props.navigatorStore.isInEditMode) {
      if (
        this.props.config.url != undefined &&
        this.props.config.url != '' &&
        this.props.type != 'phonebook' &&
        this.props.type != 'event'
      ) {
        LoggingService.trackEvent(this.constructorName, {
          ActionType: 'LinkClick',
          Targeting: this.getTargetingInfo(),
          Type: 'TopItemHeadline',
          Title: this.props.config.title,
          ItemId: this.props.index,
          ItemType: "TopItem",
          Url: this.props.config.url,
          Tenant: this.props.navigatorStore.tenant,
          Instance: this.props.navigatorStore.instance,
          UserId: this.props.navigatorStore.token,
          Version: this.props.navigatorStore.navigator.version.id,
          PageUrl: window.location.pathname.toLowerCase(),
          SiteName: Helper.getSiteCollectionFromPath(window.location.pathname)?.toLowerCase() ?? "none",
        });
      } else {
        if (!this.props.navigatorStore.isShowingMegamenu) {
          if (
            this.props.navigatorStore.navigator.megamenu.topItems[this.props.index].elementGroups != undefined &&
            this.props.navigatorStore.navigator.megamenu.topItems[this.props.index].elementGroups.length > 0
          ) {
            LoggingService.trackEvent(this.constructorName, {
              ActionType: 'LinkClick',
              Targeting: this.getTargetingInfo(),
              Type: 'TopItemHeadline',
              Title: this.props.config.title,
              ItemId: this.props.index,
              ItemType: "TopItem",
              Url: this.props.config.url,
              Tenant: this.props.navigatorStore.tenant,
              Instance: this.props.navigatorStore.instance,
              UserId: this.props.navigatorStore.token,
              Version: this.props.navigatorStore.navigator.version.id,
              PageUrl: window.location.pathname.toLowerCase(),
              SiteName: Helper.getSiteCollectionFromPath(window.location.pathname)?.toLowerCase() ?? "none",
            });
            this.props.navigatorStore.isShowingMegamenu = true;
          }
          this.props.navigatorStore.selectTopMenuItem(this.props.index);
        } else {
          if (document.getElementById('megamenuContent')) {
            setTimeout(() => {
              document.getElementById('megamenuContent').scrollTop = 0;
            }, 0);
          }
          if (this.props.index == this.props.navigatorStore.selectedTopMenuItemIndex) {
            if (!this.props.navigatorStore.isMobile) {
              this.props.navigatorStore.isShowingMegamenu = false;
            }
            this.props.navigatorStore.selectTopMenuItem(undefined);
            this.props.navigatorStore.verticalMenuExpanded = false;
          } else {
            if (
              this.props.index == this.props.navigatorStore.selectedTopMenuItemIndex &&
              this.props.navigatorStore.isMobile
            ) {
              this.props.navigatorStore.selectTopMenuItem(undefined);
            } else {
              this.props.navigatorStore.selectTopMenuItem(this.props.index);
            }
            if (document.getElementsByClassName('burgerMenu')[0]) {
              var myDiv = document.getElementsByClassName('burgerMenu')[0],
                start = myDiv.scrollTop,
                change = 0 - start,
                startDate = +new Date(),
                easeInOutQuad = function (t, b, c, d) {
                  t /= d / 2;
                  if (t < 1) return (c / 2) * t * t + b;
                  t--;
                  return (-c / 2) * (t * (t - 2) - 1) + b;
                },
                animateScroll = function () {
                  const currentDate = +new Date();
                  const currentTime = currentDate - startDate;
                  myDiv.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, 500));
                  if (currentTime < 500) {
                    requestAnimationFrame(animateScroll);
                  } else {
                    myDiv.scrollTop = 0;
                  }
                };
              animateScroll();
            }
          }
        }
        if (this.props.type == 'phonebook') {
          if (
            this.props.navigatorStore.selectedPhonebook == undefined ||
            this.props.navigatorStore.selectedPhonebook.siteCollection != this.props.config.siteCollection
          ) {
            this.props.navigatorStore.selectedPhonebook = this.props.config;
            this.props.navigatorStore.selectTopMenuItem(this.props.index);
          } else {
            this.props.navigatorStore.selectedPhonebook = undefined;
            this.props.navigatorStore.selectTopMenuItem(undefined);
          }
          this.props.navigatorStore.isShowingMegamenu = false;
        } else if (this.props.type == 'event') {
          if (
            this.props.navigatorStore.selectedEvent == undefined ||
            this.props.navigatorStore.selectedEvent.instance.instanceName !=
            this.props.config.selectedEvent.instanceName
          ) {
            this.props.navigatorStore.selectedEvent = this.props.config;
            this.props.navigatorStore.selectTopMenuItem(this.props.index);
          } else {
            this.props.navigatorStore.selectedEvent = undefined;
            this.props.navigatorStore.selectTopMenuItem(undefined);
          }
          this.props.navigatorStore.isShowingMegamenu = false;
        } else {
          this.props.navigatorStore.selectedPhonebook = undefined;
          this.props.navigatorStore.selectedEvent = undefined;
        }
      }
    } else {
      if (!this.props.navigatorStore.droppableTopItemSpotsAreShowing && !this.props.navigatorStore.isShowingAnalytics && !this.props.navigatorStore.checkedOut) {
        this.props.navigatorStore.checkForNewContent();
        this.props.navigatorStore.smartmenuTopItemIndexToEdit = undefined;
        this.props.navigatorStore.topItemIndexToEdit = this.props.index;
        this.props.navigatorStore.toggleTopItemSettings();
        this.props.navigatorStore.isShowingMegamenu = true;
        this.props.navigatorStore.selectTopMenuItem(this.props.index);
      }
      if (this.props.type == 'phonebook' || this.props.type == 'event') {
        this.props.navigatorStore.isShowingMegamenu = false;
      }
    }
  }

  private onHeaderArrowClick() {
    this.props.navigatorStore.selectedPhonebook = undefined;
    if (!this.props.navigatorStore.isShowingMegamenu) {
      LoggingService.trackEvent(this.constructorName, {
        ActionType: 'LinkClick',
        Targeting: this.getTargetingInfo(),
        Type: 'TopItemHeadline',
        Title: this.props.config.title,
        ItemId: this.props.index,
        ItemType: "TopItem",
        Url: this.props.config.url,
        Tenant: this.props.navigatorStore.tenant,
        Instance: this.props.navigatorStore.instance,
        UserId: this.props.navigatorStore.token,
        Version: this.props.navigatorStore.navigator.version.id,
        PageUrl: window.location.pathname.toLowerCase(),
        SiteName: Helper.getSiteCollectionFromPath(window.location.pathname)?.toLowerCase() ?? "none",
      });
      this.props.navigatorStore.isShowingMegamenu = true;
      this.props.navigatorStore.selectTopMenuItem(this.props.index);
    } else {
      if (this.props.index == this.props.navigatorStore.selectedTopMenuItemIndex) {
        if (!this.props.navigatorStore.isMobile) {
          this.props.navigatorStore.isShowingMegamenu = false;
        }
        this.props.navigatorStore.selectTopMenuItem(undefined);
      } else {
        if (
          this.props.index == this.props.navigatorStore.selectedTopMenuItemIndex &&
          this.props.navigatorStore.isMobile
        ) {
          this.props.navigatorStore.selectTopMenuItem(undefined);
        } else {
          this.props.navigatorStore.selectTopMenuItem(this.props.index);
        }
        if (document.getElementsByClassName('burgerMenu')[0] != undefined) {
          var myDiv = document.getElementsByClassName('burgerMenu')[0],
            start = myDiv.scrollTop,
            change = 0 - start,
            startDate = +new Date(),
            easeInOutQuad = function (t, b, c, d) {
              t /= d / 2;
              if (t < 1) return (c / 2) * t * t + b;
              t--;
              return (-c / 2) * (t * (t - 2) - 1) + b;
            },
            animateScroll = function () {
              const currentDate = +new Date();
              const currentTime = currentDate - startDate;
              myDiv.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, 500));
              if (currentTime < 500) {
                requestAnimationFrame(animateScroll);
              } else {
                myDiv.scrollTop = 0;
              }
            };
          animateScroll();
        }
      }
    }
  }

  render() {
    let layout: string = this.props.navigatorStore.navigator.design.menuBar.layout;
    let iconSize: number = layout == 'vertical' || layout == 'burger' ? 25 : 20;
    let titleWidth;
    let marginLeft = 0;
    if (this.props.config.icon != null && layout == 'horizontal') {
      marginLeft = 10;
    }
    if (layout == 'vertical' || layout == 'burger') {
      if (this.props.config.icon == null) {
        if (this.props.navigatorStore.verticalMenuExpanded || layout == 'burger') {
          marginLeft = 15;
          titleWidth = 261;
        } else {
          titleWidth = 50;
        }
      } else {
        titleWidth = 226;
      }
    }
    let height = 50;
    let mobileHeight = 50;
    let customStyles = {};
    let hasSubmenuItems =
      this.props.navigatorStore.navigator.megamenu.topItems[this.props.index] != undefined &&
      this.props.navigatorStore.navigator.megamenu.topItems[this.props.index].elementGroups != undefined &&
      this.props.navigatorStore.navigator.megamenu.topItems[this.props.index].elementGroups.length > 0;
    if (this.props.navigatorStore.selectedTopMenuItemIndex == this.props.index && this.props.navigatorStore.isMobile) {
      let mobileElementGroup = document.getElementById(`mobileElementGroup_${this.props.index}`);
      if (mobileElementGroup != undefined) {
        mobileHeight = mobileElementGroup.offsetHeight + 35;
      }
    }
    let backgroundColor = this.props.navigatorStore.navigator.design.topItems.backgroundColor;
    if (this.props.navigatorStore.selectedTopMenuItemIndex == this.props.index && layout == 'burger') {
      backgroundColor = this.props.navigatorStore.navigator.design.topItems.highlightColor;
    }
    if (layout == 'horizontal') {
      height = 40;
      backgroundColor =
        this.props.navigatorStore.selectedTopMenuItemIndex == this.props.index
          ? this.props.navigatorStore.navigator.design.menuBar.highlightColor
          : undefined;
      customStyles = {
        lineHeight: '0',
        marginRight: this.props.navigatorStore.isMobile ? 20 : 0,
        transform:
          this.props.navigatorStore.selectedTopMenuItemIndex == this.props.index ? 'rotate(-90deg)' : 'rotate(90deg)',
        left: this.props.navigatorStore.selectedTopMenuItemIndex == this.props.index ? '0' : '0',
      };
    } else {
      customStyles = {
        lineHeight: height + 'px',
        marginLeft: layout == 'horizontal' ? 10 : 0,
        transform:
          this.props.navigatorStore.selectedTopMenuItemIndex == this.props.index ? 'rotate(180deg)' : 'rotate(0deg)',
      };
    }
    if (this.props.navigatorStore.isMobile) {
      customStyles = {
        lineHeight: height + 'px',
        marginLeft: layout == 'horizontal' ? 10 : 0,
        marginRight: 20,
        transform:
          this.props.navigatorStore.selectedTopMenuItemIndex == this.props.index ? 'rotate(-90deg)' : 'rotate(90deg)',
      };
    }
    let cursor = this.props.navigatorStore.droppableTopItemSpotsAreShowing ? 'move' : 'pointer';
    if (
      this.props.navigatorStore.draggedTopItemIndex == this.props.index &&
      this.props.navigatorStore.droppableTopItemSpotsAreShowing
    ) {
      cursor = 'move';
    }
    let showIcon = this.props.config.icon != null;
    let mobileStyles = this.props.navigatorStore.isMobile ? { width: '100vw' } : {};
    let heatMapColor = this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks ? this.props.navigatorStore.getHeatMapColorHSL(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks) : "";
    let heatMapBoxShadow = this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks ? `0px 0px 10px 9px ${backgroundColor ?? this.props.navigatorStore.navigator.design.menuBar.backgroundColor} inset` : "";
    console.log(this.props.navigatorStore.hasChanged); // Forces Mobx to rerender
    const targetingInfo = this.props.navigatorStore.isInEditMode && this.getTargetingInfo("<br />");
    return (
      <div
        key={`topMenuItem_${this.props.index}`}
        id={`topMenuItem_id_${this.props.index}`}
        className={`${styles.topMenuItem} IA_OnFocus_slim ${this.props.config.url || hasSubmenuItems && !this.props.navigatorStore.isShowingAnalytics ? styles.topMenuItemLink : ''}`}
        tabIndex={
          (hasSubmenuItems &&
            this.props.config.url != undefined &&
            this.props.config.url != '' &&
            !this.props.navigatorStore.isInEditMode) ||
            !hasSubmenuItems ? 1 : -1}
        onKeyPress={(event: React.KeyboardEvent<HTMLDivElement>) => {
          if (event.key === ENTER_KEY && document.activeElement.id === `topMenuItem_id_${this.props.index}`) {
            this.onHeaderClick();
          }
        }}
        style={{
          backgroundColor: this.props.navigatorStore.isShowingAnalytics ? heatMapColor : backgroundColor,
          boxShadow: heatMapBoxShadow,
          height: this.props.navigatorStore.isMobile ? mobileHeight : height,
          paddingRight: layout == 'horizontal' && !hasSubmenuItems ? 13 : 10,
          marginRight:
            layout == 'horizontal' && this.props.navigatorStore.navigator.design.topItems.margin != undefined
              ? parseInt(this.props.navigatorStore.navigator.design.topItems.margin)
              : 0,
          opacity:
            this.props.navigatorStore.draggedTopItemIndex == this.props.index &&
              this.props.navigatorStore.droppableTopItemSpotsAreShowing && !this.props.navigatorStore.isShowingAnalytics
              ? 0.5
              : 1,
          cursor: cursor,
          ...mobileStyles,
          fontFamily: this.props.navigatorStore.fontSlots?.heading?.fontFamily
        }}
        onDragOver={(event) => {
          event.preventDefault();
          if (
            this.props.navigatorStore.droppableElementGroupSpotsAreShowing ||
            this.props.navigatorStore.droppableElementSpotsAreShowing
          ) {
            this.props.navigatorStore.selectTopMenuItem(this.props.index);
          }
        }}
        draggable={this.props.navigatorStore.droppableTopItemSpotsAreShowing}
        onDragStart={() => {
          this.props.navigatorStore.setDraggedTopItem(this.props.index);
        }}
        onDragEnd={() => {
          this.props.navigatorStore.draggedTopItemIndex = undefined;
        }}
        title={this.props.config != undefined ? this.props.config.title : ''}
      >
        {targetingInfo &&
          <NavigatorTargetingTooltip
            highlightColor={this.props.navigatorStore.highlightColor}
            targetingInfo={targetingInfo}
          />
        }
        {showIcon && (
          <a
            tabIndex={-1}
            data-interception={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "off" : "on"}
            target={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "_blank" : "_self"}
            onClick={() => {
              if (!(this.props.navigatorStore.isMobile && (this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally))) {
                this.onHeaderClick();
              } else if (this.props.navigatorStore.isMobile) {
                this.onHeaderClick();
              }
            }}
            href={
              this.props.config.url != undefined &&
                this.props.config.url != '' &&
                !this.props.navigatorStore.isInEditMode
                ? this.props.config.url
                : undefined
            }
          >
            <div
              className={styles.topItemIcon}
              style={{
                width: iconSize,
                height: iconSize,
                marginTop: layout == 'horizontal' ? 10 : 0,
              }}
            >
              <IAIcon
                title={this.props.config.icon}
                size={iconSize}
                color={
                  this.props.navigatorStore.selectedTopMenuItemIndex === this.props.index
                    ? this.props.navigatorStore.navigator.design.topItems.highlightTextColor
                    : this.props.navigatorStore.navigator.design.topItems.textColor
                }
              />
            </div>
          </a>
        )}
        <a
          tabIndex={-1}
          data-interception={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "off" : "on"}
          target={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "_blank" : "_self"}
          onClick={() => {
            if (!(this.props.navigatorStore.isMobile && (this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally))) {
              this.onHeaderClick();
            } else if (this.props.navigatorStore.isMobile) {
              this.onHeaderClick();
            }
          }}
          href={
            this.props.config.url != undefined && this.props.config.url != '' && !this.props.navigatorStore.isInEditMode
              ? this.props.config.url
              : undefined
          }
        >
          <div
            className={styles.topMenuItemTitle}
            style={{
              color:
                this.props.navigatorStore.selectedTopMenuItemIndex == this.props.index
                  ? this.props.navigatorStore.navigator.design.topItems.highlightTextColor ||
                  this.props.navigatorStore.navigator.design.topItems.textColor
                  : this.props.navigatorStore.navigator.design.topItems.textColor,
              letterSpacing: this.props.navigatorStore.navigator.design.topItems.letterSpacing,
              textTransform: this.props.navigatorStore.navigator.design.topItems.textTransform,
              fontWeight: this.props.navigatorStore.navigator.design.topItems.fontWeight,
              fontSize: this.props.navigatorStore.navigator.design.topItems.fontSize,
              width: layout == 'horizontal' ? 'auto' : titleWidth,
              marginLeft: marginLeft,
              lineHeight: `${height}px`,
              height: height,
              textAlign: 'left',
              paddingLeft:
                (this.props.navigatorStore.isMobile && this.props.config.icon == undefined) ||
                  (this.props.navigatorStore.isMobile && this.props.config.icon == '')
                  ? 20
                  : 0,
              opacity: this.props.navigatorStore.isShowingAnalytics ? 1 : "",
            }}
          >
            <IAConditionalTooltipWrapper
              condition={this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks}
              tooltipContent={
                <div>
                  {this.props.navigatorStore.getClickTooltipLocalizationString(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks)}
                  ({this.props.navigatorStore.getPercentageOfClickComparedToAllClicks(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks)}%)
                </div>
              }
              wrapper={ (content) =>
                <>{content}</>
              }  
            >
              {layout == 'vertical' &&
              !this.props.navigatorStore.verticalMenuExpanded &&
              this.props.config.title.length > 2 &&
              !showIcon
              ? this.props.config.title.substring(0, 2)
              : this.props.config.title}
            </IAConditionalTooltipWrapper>
          </div>
        </a>
        {hasSubmenuItems && !this.props.navigatorStore.droppableTopItemSpotsAreShowing && (
          <div
            id={"topItemArrowNavigator_" + this.props.index}
            ref={(ref) => KeyNavigationGlobalCache.topItemRefs[this.props.index] = ref}
            className={[styles.topItemArrow, "IA_OnFocus"].join(" ")}
            style={customStyles}
            tabIndex={1}
            onClick={() => this.onHeaderArrowClick()}
            onKeyPress={(event: React.KeyboardEvent<HTMLDivElement>) => {
              if (event.key === ENTER_KEY) {
                this.onHeaderArrowClick();
              }
            }}
            onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
              if (event.key === DOWNARROW_KEY && this.props.index == this.props.navigatorStore.selectedTopMenuItemIndex) {
                event.preventDefault();
                var megaMenu = document.getElementById("megamenuContent");
                for (let i = 0; i < megaMenu.childNodes.length; i++) {
                  // iterates columns
                  let column = megaMenu.childNodes[i];
                  for (let j = 0; j < column.childNodes.length; j++) {
                    // iterates groups
                    let elementGroup = column.childNodes[j];
                    for (let k = 0; k < elementGroup.childNodes.length; k++) {
                      let el = elementGroup.childNodes[k] as HTMLElement;
                      if (k === 0) {
                        // checks if the header is focusable
                        let classes: string[] = el.className != undefined ? el.className.split(" ") : [];
                        if (classes.indexOf("IA_OnFocus") != -1) {
                          el.focus();
                          return;
                        }
                      } else {
                        // checks if elements below header is clickable
                        let elChild = el.childNodes[0] as HTMLElement;
                        let classes: string[] = elChild.className != undefined ? elChild.className.split(" ") : [];
                        if (classes.indexOf("IA_OnFocus") != -1) {
                          elChild.focus();
                          return;
                        }
                      }
                    }
                  }
                }
              }
            }}
          >
            <IAIcon
              title={'Arrow'}
              size={14}
              color={
                this.props.navigatorStore.selectedTopMenuItemIndex === this.props.index
                  ? this.props.navigatorStore.navigator.design.topItems.highlightTextColor
                  : this.props.navigatorStore.navigator.design.topItems.textColor
              }
            />
          </div>
        )}
        {this.props.navigatorStore.isMobile &&
          this.props.navigatorStore.navigator.megamenu.topItems[this.props.index] != undefined &&
          this.props.navigatorStore.navigator.megamenu.topItems[this.props.index].elementGroups != undefined &&
          this.props.navigatorStore.navigator.megamenu.topItems[this.props.index].elementGroups.length > 0 && (
            <MobileElementGroup topItemIndex={this.props.index} elementGroups={this.props.elementGroups} />
          )}
      </div>
    );
  }
}
